var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartBar } from '../svg-elements/module';
import { GraphControllerV2 } from './graph-v2';
import { breakpoints } from '../_styleguide/_breakpoints';
var BandBars = /** @class */ (function (_super) {
    __extends(BandBars, _super);
    function BandBars(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    BandBars.prototype.pre = function () {
        this._addMargin(20, 40, 0, 0);
        this._addPadding(0, 0, 30, 0);
        this._addScale('x', 'band', 'horizontal', 'label');
        this._addScale('y', 'linear', 'vertical', 'value');
        this._addAxis('x', 'x', 'bottom');
        this._addAxis('y', 'y', 'left');
    };
    BandBars.prototype.init = function () {
        _super.prototype._init.call(this);
        if (window.innerWidth < breakpoints.sm && this.mapping.args && this.mapping.args[0] === 'alternateTicks') {
            this._addMargin(20, 140, 0, 0);
        }
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = (window.innerWidth < breakpoints.sm) ? "320px" : "320px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.config.paddingInner = .25;
        this.config.paddingOuter = 0.25;
        this.chartBar = new ChartBar(this);
        if (this.data[0][this.firstMapping['column']] != null && this.data[0][this.firstMapping['column']] != 0) {
            this.update(this.data, "all", false);
        }
    };
    BandBars.prototype.prepareData = function (data) {
        var _this = this;
        var slice = [];
        var d = data.find(function (j) { return j['gemeente'].toLowerCase() === _this.segment; });
        console.log(d);
        for (var _i = 0, _a = this.mapping.parameters[0]; _i < _a.length; _i++) {
            var mapping = _a[_i];
            var column = Array.isArray(mapping) ? mapping[0].column : mapping.column;
            slice.push({
                label: mapping.label,
                colour: mapping.colour,
                value: d[column],
                gemeente: d['gemeente'],
                _date: d['_date']
            });
        }
        return {
            "history": null,
            "latest": null,
            "slice": slice,
        };
    };
    BandBars.prototype.draw = function (data) {
        var _this = this;
        this.scales.x.set(data.slice.map(function (d) { return d[_this.parameters.x]; }));
        this.chartBar.draw(data.slice);
    };
    BandBars.prototype.redraw = function (data) {
        var _this = this;
        this.yScale = this.scales.y.set(data.slice.map(function (d) { return d[_this.parameters.y]; }));
        _super.prototype.redraw.call(this, data);
        // redraw data
        this.chartBar.redraw(data.slice);
    };
    BandBars.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return BandBars;
}(GraphControllerV2));
export default BandBars;
